// WagmiConnectProvider — wraps app in WagmiProvider + QueryClientProvider
// Replaces AppKitProvider for reliable EVM wallet connections

import { useEffect } from 'react';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { wagmiConfig } from './config.ts';
import { clearStaleWcOnMount } from './cleanup.ts';
import type { ReactNode, JSX } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false },
  },
});

type WagmiConnectProviderProps = Readonly<{
  readonly children: ReactNode;
}>;

export const WagmiConnectProvider = ({ children }: WagmiConnectProviderProps): JSX.Element => {
  useEffect(clearStaleWcOnMount, []);

  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
};
